/**
 * Validate that a navigable URL uses a safe scheme.
 * Allowed: http, https, mailto, tel
 * Disallowed: javascript, data, vbscript, file, etc.
 * @param {string} url
 * @returns {boolean}
 */
export const isSafeUrl = (url = '') => {
  if (!url) return false;
  try {
    const parsed = new URL(url, window.location.origin);
    return ['http:', 'https:', 'mailto:', 'tel:'].includes(parsed.protocol);
  } catch {
    return false;
  }
};

/**
 * Validate that an image URL is safe.
 * Only http: and https: are accepted for images.
 * @param {string} url
 * @returns {boolean}
 */
export const isSafeImageUrl = (url = '') => {
  if (!url) return false;
  try {
    const parsed = new URL(url, window.location.origin);
    return ['http:', 'https:'].includes(parsed.protocol);
  } catch {
    return false;
  }
};
